import routes from './questions.routes';

export const questionsModule = {
    routes
};